import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useLocale } from "@/lib/locale";

export default function AuthCallback() {
    const nav = useNavigate();
    const { setUser } = useAuth();
    const { t } = useLocale();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            nav("/login", { replace: true });
            return;
        }
        const session_id = match[1];
        (async () => {
            try {
                const { data } = await api.post("/auth/google-session", { session_id });
                setUser(data.user);
                // Clean URL
                window.history.replaceState({}, "", "/dashboard");
                nav("/dashboard", { replace: true, state: { user: data.user } });
            } catch {
                nav("/login", { replace: true });
            }
        })();
    }, [nav, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center text-ink-textLow font-serif italic text-xl animate-fade-in-slow">
            {t("auth.callback_loading")}
        </div>
    );
}
